module.exports = __webpack_public_path__ + "img/lokac_w.ede733f6.svg";